import { default as indexhmGlMx7tAoMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/[[step]]/index.vue?macro=true";
import { default as ClubCQ7PS5RktmCpMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/ClubCQ.vue?macro=true";
import { default as ClubCQWarningjiy9YTuyVqMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/ClubCQWarning.vue?macro=true";
import { default as EmailPrivacyt26CSehQknMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/EmailPrivacy.vue?macro=true";
import { default as HomehiyHE0Ji4GMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/Home.vue?macro=true";
import { default as IncomeDataq1R9ah5K2GMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/IncomeData.vue?macro=true";
import { default as FootersynhmyQ5C8Meta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/static/Footer.vue?macro=true";
import { default as componentsHJ2suN1CSaMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/components.ts?macro=true";
import { default as handlersWxWdQlyeUBMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/handlers.ts?macro=true";
import { default as mappingALGGl7VzXAMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/mapping.ts?macro=true";
import { default as props6WdkbQQxzyMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/props.ts?macro=true";
import { default as devK2wMD81f1TMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/data/dev.ts?macro=true";
import { default as deliveryDatafbJX7jKzJvMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/deliveryData.ts?macro=true";
import { default as esitoDataXMwfDVE8zKMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/esitoData.ts?macro=true";
import { default as incomeDataqoML3uTGVGMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/incomeData.ts?macro=true";
import { default as paymentDatayNtT6iYrwsMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/paymentData.ts?macro=true";
import { default as routesNFIssJ3aMdMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/routes.ts?macro=true";
import { default as indexAePnuN3rm9Meta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/utils/index.ts?macro=true";
import { default as redirectsftq2j7bAfeMeta } from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/utils/redirects.ts?macro=true";
export default [
  {
    name: "step",
    path: "/:step?",
    meta: indexhmGlMx7tAoMeta || {},
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/[[step]]/index.vue")
  },
  {
    name: "components-ClubCQ",
    path: "/components/ClubCQ",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/ClubCQ.vue")
  },
  {
    name: "components-ClubCQWarning",
    path: "/components/ClubCQWarning",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/ClubCQWarning.vue")
  },
  {
    name: "components-EmailPrivacy",
    path: "/components/EmailPrivacy",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/EmailPrivacy.vue")
  },
  {
    name: "components-Home",
    path: "/components/Home",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/Home.vue")
  },
  {
    name: "components-IncomeData",
    path: "/components/IncomeData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/IncomeData.vue")
  },
  {
    name: "components-static-Footer",
    path: "/components/static/Footer",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/components/static/Footer.vue")
  },
  {
    name: "config-components",
    path: "/config/components",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/components.ts")
  },
  {
    name: "config-handlers",
    path: "/config/handlers",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/handlers.ts")
  },
  {
    name: "config-mapping",
    path: "/config/mapping",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/mapping.ts")
  },
  {
    name: "config-props",
    path: "/config/props",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/config/props.ts")
  },
  {
    name: "data-dev",
    path: "/data/dev",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/data/dev.ts")
  },
  {
    name: "mappings-deliveryData",
    path: "/mappings/deliveryData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/deliveryData.ts")
  },
  {
    name: "mappings-esitoData",
    path: "/mappings/esitoData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/esitoData.ts")
  },
  {
    name: "mappings-incomeData",
    path: "/mappings/incomeData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/incomeData.ts")
  },
  {
    name: "mappings-paymentData",
    path: "/mappings/paymentData",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/mappings/paymentData.ts")
  },
  {
    name: "routes",
    path: "/routes",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/routes.ts")
  },
  {
    name: "utils",
    path: "/utils",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/utils/index.ts")
  },
  {
    name: "utils-redirects",
    path: "/utils/redirects",
    component: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/themes/prestito5/utils/redirects.ts")
  },
  {
    path: "/auto",
    name: "auto"
  },
  {
    path: "/consolidamento",
    name: "consolidamento"
  }
]